import React from "react";
import P2PRegistrationBase from "../templates/P2PRegistrationBase";
import ConnectedFormStatus from "./ConnectedFormStatus";
import "./RegistrationClosedPage.scss";

const RegistrationClosedPage = () => (
    <P2PRegistrationBase>
        <div className="registration-closed-page">
            <div className="registration-closed-page__content">
                <ConnectedFormStatus />
            </div>
        </div>
    </P2PRegistrationBase>
);

export default RegistrationClosedPage;
